import {
  SEND_MESSAGE_START,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_ERROR,
} from '../../constants';
import { updateReservation } from '../Reservation/updateReservation';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import showToaster from '../../helpers/toasterMessages/showToaster';
import { threadItemsQuery, sendMessage as mutation } from '../../lib/graphql';
import fetch from '../../core/fetch';

export const sendMessageAction = (
  threadId,
  threadType,
  content,
  type,
  startDate,
  endDate,
  personCapacity,
  reservationId,
  receiverName,
  senderName,
  receiverType,
  receiverEmail,
  startTime,
  endTime,
  currentPage,
  searchKey,
  listIdKey,
  startDateFilter,
  endDateFilter,
  orderBy,
  dateFilter
) => {
  return async (dispatch, getState, { client }) => {
    try {

      dispatch(setLoaderStart('hostAction'));
      dispatch({
        type: SEND_MESSAGE_START,
      });

      const { data } = await client.mutate({
        mutation,
        variables: {
          threadId,
          content,
          type,
          startDate,
          endDate,
          personCapacity,
          reservationId,
          startTime,
          endTime
        },
        refetchQueries: [
          {
            query: threadItemsQuery,
            variables: {
              threadId,
              threadType
            },
          }
        ]
      });

      if (data?.sendMessage?.status == 'alreadyPerformed') {
        showToaster({ messageId: 'alreadyPerformedAction', toasterType: 'error' })
        dispatch({
          type: SEND_MESSAGE_ERROR,
        });
        return { success: false, errorType: 'alreadyPerformed' };
      } else if (data?.sendMessage?.status == 'content_blocked') {
        // Content filter blocked the message - show error to user
        const errorMessage = data?.sendMessage?.errorMessage;
        showToaster({ messageId: 'contentBlocked', toasterType: 'error', customMessage: errorMessage });
        dispatch({
          type: SEND_MESSAGE_ERROR,
          payload: { contentBlocked: true, errorMessage }
        });
        return { success: false, errorType: 'content_blocked', errorMessage };
      } else if (data?.sendMessage?.status != 'userbanned') {
        if (reservationId != null && reservationId != undefined) {
          dispatch(updateReservation(reservationId, type, threadType, threadId, currentPage, searchKey, listIdKey, startDateFilter, endDateFilter, orderBy, dateFilter));
        }

        dispatch({
          type: SEND_MESSAGE_SUCCESS,
        });

        if (type === 'message') {
          // Send email notification via server route (with locale support)
          try {
            await fetch('/sendEmailWithLocale', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                to: receiverEmail,
                type: 'message',
                content: {
                  receiverName,
                  senderName,
                  receiverType,
                  type: receiverType,
                  message: content,
                  threadId
                }
                // receiverUserId will get locale from profile on server
              }),
              credentials: 'include'
            });
          } catch (emailError) {
            console.error('Failed to send email notification:', emailError);
          }
        }
      }
      dispatch(setLoaderComplete('hostAction'));
    } catch (error) {
      dispatch({
        type: SEND_MESSAGE_ERROR,
        payload: {
          error
        }
      });
      dispatch(setLoaderComplete('hostAction'));
      return false;
    }
    return true;
  };
}